import { render, staticRenderFns } from "./PeopleInstitutionList.vue?vue&type=template&id=421f8667&scoped=true&"
import script from "./PeopleInstitutionList.vue?vue&type=script&lang=js&"
export * from "./PeopleInstitutionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421f8667",
  null
  
)

export default component.exports